import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Error as IcoError } from '@mediahuis/chameleon-theme-wl/icons';
import Caption from '../Caption';
import Icon from '../Icon';
import styles from './index.module.css';
const Message = /*#__PURE__*/function () {
  const Message = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      id,
      children,
      error,
      ...rest
    } = _ref;
    return /*#__PURE__*/React.createElement(Caption, _extends({
      as: "div",
      color: error ? 'redBase' : 'grey50',
      id: id,
      ref: ref,
      role: error ? 'alert' : undefined,
      className: cx(styles.root, rest.className)
    }, rest), error && /*#__PURE__*/React.createElement(Icon, {
      className: styles.icon,
      as: IcoError,
      size: "small"
    }), children);
  });
  Message.displayName = 'Message';
  Message.identifier = Message.displayName; // used in docs website
  Message.clonableProps = ['marginProps', 'paddingProps', 'floatProps'];
  Message.propTypes = {
    /** Contents displayed within the message. */
    children: PropTypes.node,
    /** Visually displayed as error text. Will add the necessary role attribute. */
    error: PropTypes.bool,
    /** Id of the element, required for reference. */
    id: PropTypes.string
  };
  return Message;
}();
export default Message;